import React,{Component, Fragment} from 'react';
import PaymentModule from '../../Misc/PaymentModule/index';
import {_addNotificationError,
    allowNumericWithdecimal,
    _addNotification,
    getPaymentGatewayCharges, 
    getPaymentGateway,
    convertTwoDecimalPoint, 
    getLoginParent,groupBy} from "../../../server/util";
import {
    transaction_Charge,
    transaction_Other_Charge,
    currency_symbol, 
    paymentGatewayOptions, 
    paymentOptionValues,
    stripeInfo} from '../../../server/constants';
    
const paymentMethods={
        'CASH' : 'Cash/Check payment',
        'CARD':'Card payment'
    };
class PreviewDetails extends Component{
    validatePayment=()=>{
        if(parseFloat(convertTwoDecimalPoint(this.props.totalAmount,2))>0 && this.props.paymentType=== Object.keys(paymentMethods)[1]){
            return true;
        }
        return false
    }
    formatPaymentObject=()=>{
        const students=this.props.students;
        const studentPackages=this.props.studentPackages;
        const filteredStudents=Object.values(students||{}).filter((s,i)=>{
            return !(!s.isSelected && !s.isRegistered)
        });
        let _subscriptionsTrxByStds=[];
        const _authorisedPersons=[];
        let _registerStudents=(((this.props.studentPackages[0]||[])[0]||{}).regSudents||[]);
        filteredStudents.map(stu=>{
            const regPackage=_registerStudents.find(s=>{return s.id==stu.id});
            const pack=stu.packageList[0];
            const _authorisedPersonsBySt=[];
            (stu.authorisedPersons||[]).map(per=>{
                if(((per.firstName||'').trim()).length>0){
                    _authorisedPersons.push({
                        authorizedId:per.authorizedId,
                        firstName:per.firstName,
                        lastName:per.lastName,
                        phoneNo:per.phoneNo,
                        relation:per.relation,
                        stdRecId:stu.id,
                        isActive:per.isActive
                    });
                    _authorisedPersonsBySt.push({
                        authorizedId:per.authorizedId,
                        firstName:per.firstName,
                        lastName:per.lastName,
                        phoneNo:per.phoneNo,
                        relation:per.relation,
                        stdRecId:stu.id,
                        isActive:per.isActive
                    })
                }                
            })
            if(!regPackage && (pack.packageId||'')=='' && _authorisedPersonsBySt.length==0 ){
                return null;
            }else{
                if((pack.packageId||'')!==''){
                    const stuSelectedPacks=this.props.studentPackages[stu.id];
                    if(pack.frequency== "One Time"){
                        if(((stuSelectedPacks[0]||{}).oneTimeDates||[]).length>0)
                        {
                            ((stuSelectedPacks[0]||{}).oneTimeDates||[]).map(dateObj=>{
                                _subscriptionsTrxByStds.push({
                                    studentUser:{
                                        userId:stu.id
                                    },
                                    startDate: (dateObj.date||'')===''?null: dateObj.date.format('YYYY-MM-DD'),
                                    endDate: (dateObj.date||'')===''?null:dateObj.date.format('YYYY-MM-DD'),
                                    paidAmt: (dateObj.amount||'')===''?null:dateObj.amount,
                                    schoolPackage:{
                                        packageId: (pack.packageId||'')===''?null:pack.packageId
                                    }
                                });
                            })
                        }
                    }else{
                        const _price= ((stuSelectedPacks||[]).find(pak=>{
                            return pak.packageId==pack.packageId;
                        })||{}).amount||'';
                        _subscriptionsTrxByStds.push({
                            studentUser:{
                                userId:stu.id
                            },
                            startDate: (pack.startDt||'')===''?null: pack.startDt.format('YYYY-MM-DD'),
                            endDate: (pack.endDt||'')===''?null:pack.endDt.format('YYYY-MM-DD'),
                            paidAmt: (_price||'')===''?null:_price,
                            schoolPackage:{
                                packageId: (pack.packageId||'')===''?null:pack.packageId
                            }
                        });
                    }
                }
                if(regPackage){
                    _subscriptionsTrxByStds.push({
                        studentUser:{
                            userId:stu.id
                        },
                        startDate: null,
                        endDate: null,
                        paidAmt:regPackage.amount,
                        schoolPackage:{
                            packageId: regPackage.packageId
                        }
                    });
                }
            }         
        })
        const paymentObject={
            mealSchoolId: this.props.schoolId,
            schoolName:'',
            logoUrl:'',
            transactionType:'Deposit',
            paymentType:"Online",
            totalTransactionAmount:parseFloat(convertTwoDecimalPoint(this.props.totalAmount,2)),
            balAmount:parseFloat(convertTwoDecimalPoint(this.props.totalAmount,2)),
            transactionFees:getPaymentGatewayCharges(this.props.schoolId,this.props.totalAmount, false),
            subscriptionsTrxByStds:_subscriptionsTrxByStds,
            pickupAuthorizeds:_authorisedPersons
        }
        return paymentObject;
    }
    render(){
        const charges=(getPaymentGatewayCharges(this.props.schoolId,this.props.totalAmount,true));
        return(
        <Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="panel panel-default">
                        <div className="panel-body">
                            <div className="border_thumb">
                                <div className="row">
                                    <div className="col-md-12">                                        
                                        <div className="caption">
                                            <div className="leftBox">
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <h5>Preview Purchase Details</h5>
                                                    </div>
                                                </div>
                                                <hr style={{margin:'5px'}} />
                                                <div className="row">
                                                    <div className="col-md-12">
                                                    <table className="table">
                                                        <thead>
                                                            <tr>
                                                                <th style={{width:'30px'}}>S.No</th>
                                                                <th>Details</th>
                                                                <th>Price</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                Object.values(this.props.studentPackages||{}).map((pack,i)=>{
                                                                    return (pack||[]).map(item=>{
                                                                            return <tr>
                                                                                <td>{i+1}</td>
                                                                                <td>{item.charge}</td>
                                                                                <td>{`${this.props.currency} ${convertTwoDecimalPoint(item.amount)}`}</td>
                                                                            </tr>
                                                                        })
                                                                    })
                                                            }
                                                        </tbody>
                                                        <tfoot style={{backgroundColor:'#faf5f5'}}>
                                                        { this.props.paymentType===Object.keys(paymentMethods)[1]?
                                                            <tr style={{display:`${this.props.excludeCharges?'none':'table-row'}`}}>
                                                                <td></td>
                                                                <td>Transaction Charges</td>
                                                                <td>{`${this.props.currency} ${convertTwoDecimalPoint(charges)}`}</td>
                                                            </tr>:null
                                                        }
                                                            <tr>
                                                                <td></td>
                                                                <td>Total</td>
                                                                {
                                                                    this.props.paymentType===Object.keys(paymentMethods)[1]?                                                                    
                                                                    <td>{`${this.props.currency} ${convertTwoDecimalPoint(parseFloat(this.props.totalAmount)+ (this.props.excludeCharges?0:parseFloat(charges)))}`}</td>:
                                                                    <td>{`${this.props.currency} ${convertTwoDecimalPoint(parseFloat(this.props.totalAmount))}`}</td>
                                                                }                                                                
                                                            </tr>
                                                        </tfoot>
                                                    </table>

                                                    </div>
                                                </div>                                                    
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-10">
                    <button className="btn btn-prev btn-xs bg-color-2 pull-let" onClick={(e)=>{
                        this.props.jumpToStep(2)
                    }}>Previous
                    </button>
                </div>
                <div className="col-xs-2">
                {
                    this.validatePayment()===false?<button className="btn btn-success btn-sm btn-block" onClick={(e)=>{
                        const formatObj=this.formatPaymentObject()                                
                                let payObj={
                                "loggedUser": getLoginParent(),
                                "mealSchool": {
                                    "schoolId": this.props.schoolId
                                },
                                "transactionToken": null,
                                //"paymentType":"Online",
                                "totalPaidAmt":formatObj.totalTransactionAmount,
                                "transactionFees":formatObj.transactionFees,
                                "appFeeAmount":0,
                                "subscriptionsTrxByStds":formatObj.subscriptionsTrxByStds,
                                "pickupAuthorizeds":formatObj.pickupAuthorizeds
                                };
                                this.props.onToken(payObj);

                    }}>Pay</button>:
                            <PaymentModule  paymentDesc={"BCAC_PAY"}
                            schoolId={this.props.schoolId}
                            userInfo={{
                                parent:getLoginParent()
                                }}
                            paymentObj={this.formatPaymentObject()} 
                            excludeCharges={this.props.excludeCharges}
                            onToken={(token)=>{
                                const _stripeInfo=stripeInfo(this.props.schoolId)
                                const formatObj=this.formatPaymentObject()                                
                                let payObj={
                                "loggedUser": getLoginParent(),
                                "mealSchool": {
                                    "schoolId": this.props.schoolId
                                },
                                "paymentType":"Online",
                                "totalPaidAmt":formatObj.totalTransactionAmount,
                                "transactionFees":formatObj.transactionFees,
                                "appFeeAmount":_stripeInfo.application_free,
                                "subscriptionsTrxByStds":formatObj.subscriptionsTrxByStds,
                                "pickupAuthorizeds":formatObj.pickupAuthorizeds
                                };
                                if(typeof(token)==='string'){
                                    payObj["transactionToken"]=token;
                                }
                                else{
                                    payObj["transferId"]=token.transferId;
                                    payObj["chargeId"]=token.chargeId;
                                }
                                this.props.onToken(payObj);
                            }}
                            //onPaymentDone={this.onPaymentDone} 
                            showHideLoading={this.showHideLoading}
                            onValidationError={(error)=>{
                                //_addNotificationError(error,this);
                            }}
                             />
                            
                        }
                </div>
            </div>
        </Fragment>)
    }
}
export default PreviewDetails;


// WEBPACK FOOTER //
// ./src/components/Parent/bcac/previewDetails.jsx